import {
  Component,
  ElementRef,
  Renderer2,
  ChangeDetectorRef,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { MatTooltip } from '@angular/material/tooltip';
import {DetailScreensService} from '../detail-screens-module/services/detail-screens-service';
import {DomService} from '../../../services/dom-service/dom.service';
import {ProductOverviewService} from '../../../services/product-overview/product-overview.service';
import {ArrangementLevelComponent} from '../abstract-classes/arrangement-level/arrangement-level.component';
import {ToasterService} from '../../../toaster-module/toaster-service/toaster.service';
import {PopupService} from '../popup-component/popup.service/popup.service';
import {UiHelperService} from '../../../services/shared/helpers/ui-helper.service';

@Component({
  selector: 'app-sub-arrangement-node',
  templateUrl: '../abstract-classes/arrangement-level/arrangement-level.component.html',
  styleUrls: ['../abstract-classes/po-node/ponode.component.css'],
})
export class SubArrangementNodeComponent  extends ArrangementLevelComponent {
  @ViewChild('arrangementUrlTooltip') tooltip: MatTooltip;

  nodeType = 'sub-arrangement-node';
  componentURL: string | null = null;

  constructor(domService: DomService, private productOverviewService: ProductOverviewService,
              private el: ElementRef, private renderer: Renderer2, private changeRef: ChangeDetectorRef,
              detailsScreenService: DetailScreensService, toasterService: ToasterService, popupService: PopupService,
              protected uiHelper: UiHelperService, private router: Router) {
    super(domService, detailsScreenService, toasterService, popupService, uiHelper);
  }

  ngOnInit() {
    const qp = this.router.routerState.snapshot.root.queryParamMap;
    this.componentURL = qp.get('componentURL');
    this.data.count = '';
  }

  onClick() {
    super.onClick();
    if (this.childrenInitialized === false) {
      this.initializeChildren();
    }
  }

  expand() {
    if (this.expandable) {
      super.expand();
      if (this.childrenInitialized === false) {
        this.initializeChildren();
      }
      this.children.forEach((child) => {
        child.expand();
      });
    }
  }

  private initializeChildren(): void {
    const numberOfChildren = this.hierarchyChildren.length;

    this.hierarchyChildren.forEach((child, index) => {
      const component = this.createComponent(child, SubArrangementNodeComponent);
      if (component) {
        if (index === numberOfChildren - 1) {
          component.isLastChild = true;
        }
        this.children.push(component);
      }
    });

    this.changeRef.detectChanges();
    this.childrenInitialized = true;
  }

  getArrangementUrl() {
    this.productOverviewService.getArrangementUrl(this.data.arrangementNumber, this.data.administrationCode,
      this.data.bankCode)
      .subscribe(
        (resp) => {
          this.data.arrangementUrl = resp['url'];
          if (this.componentURL?.includes('agentcockpit')) {
            window.open(this.data.arrangementUrl, 'SIEBEL');
           } else {
             window.top.location.href = this.data.arrangementUrl;
           }
        },
        (error) => {
          this.toasterService.startErrorToast([error.error.errorMessage], '', true);
        });
  }

}
